module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"seeMore":"Ver mais"},"en":{"seeMore":"See more"}}')
  delete Component.options._Ctor
}
